var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Admin Users")])]), _c('a-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.showCreateModal
    }
  }, [_vm._v(" Add Admin ")])], 1)]), _c('div', {
    staticClass: "card-body"
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.admins,
      "pagination": {
        pageSize: 10
      },
      "row-key": function rowKey(record) {
        return record.id;
      }
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function fn(text, record) {
        return [_vm._v(" " + _vm._s(record.name) + " "), _vm.isCurrentUser(record) ? _c('a-tag', {
          staticClass: "ml-2"
        }, [_vm._v("You")]) : _vm._e()];
      }
    }, {
      key: "status",
      fn: function fn(text, record) {
        return [_c('a-tag', {
          attrs: {
            "color": record.isActive ? 'green' : 'red'
          }
        }, [_vm._v(" " + _vm._s(record.isActive ? 'Active' : 'Disabled') + " ")])];
      }
    }, {
      key: "lastLogin",
      fn: function fn(text, record) {
        return [record.lastLogin ? _c('span', [_vm._v(_vm._s(record.lastLogin))]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Never")])];
      }
    }, {
      key: "actions",
      fn: function fn(text, record) {
        return [_vm.isCurrentUser(record) ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("—")]) : record.isActive ? _c('a-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.confirmDeactivate(record);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "stop"
          }
        }), _vm._v(" Disable ")], 1) : _c('a-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function click($event) {
              return _vm.reactivate(record);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "play-circle"
          }
        }), _vm._v(" Enable ")], 1)];
      }
    }])
  })], 1)])]), _c('a-modal', {
    attrs: {
      "title": "Add Admin User",
      "visible": _vm.modalVisible,
      "confirm-loading": _vm.modalLoading,
      "ok-text": "Create",
      "width": 600
    },
    on: {
      "ok": _vm.handleModalOk,
      "cancel": _vm.handleModalCancel
    }
  }, [_c('a-alert', {
    staticClass: "mb-3",
    attrs: {
      "message": "The new admin will receive an email with a link to set their password.",
      "type": "info",
      "show-icon": ""
    }
  }), _c('a-form-model', {
    ref: "adminForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "First name",
      "prop": "firstName"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "firstName", $$v);
      },
      expression: "form.firstName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Last name",
      "prop": "lastName"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "lastName", $$v);
      },
      expression: "form.lastName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Email",
      "prop": "username"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.username,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "username", $$v);
      },
      expression: "form.username"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }